import { combineReducers } from "redux";
import { danaReportState } from "./danaReportReducer";

export const danaReportReducer = combineReducers({
    danaReportState: danaReportState
});
